import Vue from 'vue'
import Router from 'vue-router'
import Listes from '@/views/Listes.vue'
import Listeindiv from '@/views/Listeindiv.vue'
import Home from '@/views/Home.vue'
import Enregistrement from '@/components/user/Enregistrement.vue'
import Connexion from '@/components/user/Connexion.vue'
import AuthGuard from './auth-guard'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Listes,
      beforeEnter: AuthGuard
    },
    {
      path: '/listes',
      name: 'listes',
      component: Listes,
      beforeEnter: AuthGuard
    },
    {
      path: '/liste/:id',
      name: 'liste',
      component: Listeindiv,
      props: true,
      beforeEnter: AuthGuard
    },
    {
      path: '/enregistrement',
      name: 'enregistrement',
      component: Enregistrement
    },
    {
      path: '/connexion',
      name: 'connexion',
      component: Connexion
    }
  ]
})
